"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseGoogleAddressComponents = void 0;
var parseGoogleAddressComponents = function (addressComponents) {
    var components = {};
    addressComponents.forEach(function (addressComponent) {
        addressComponent.types.forEach(function (type) {
            components[type] = addressComponent.long_name;
        });
    });
    return components;
};
exports.parseGoogleAddressComponents = parseGoogleAddressComponents;
//# sourceMappingURL=Location.js.map